export default "__VITE_ASSET__cf24f283__"